import iconClose from 'assets/images/eventBoatRacingT10/icon-close-2.png'
import { Modal } from 'react-bootstrap'

function NotificationModal({ show, title, content, handleCancel, footer }) {
	return (
		<Modal
			show={show}
			onHide={handleCancel}
			centered
			className='notification-modal'
		>
			<img src={iconClose} alt="icon-close" className='icon-close' onClick={handleCancel} />
			<Modal.Header className='notification-modal-head'>
				{title}
			</Modal.Header>
			<Modal.Body className='notification-modal-content'>
				<span>
					{content}
				</span>
			</Modal.Body>
			<Modal.Footer >
				<div className='notification-modal-footer'>
					{footer}
				</div>
			</Modal.Footer>
		</Modal>
	)
}

export default NotificationModal
